var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("Copyright © 2021 "),_c('a',{attrs:{"href":"#","target":"_blank","rel":"nofollow"}},[_vm._v("Hobi")]),_vm._v(", All rights Reserved")])
}]

export { render, staticRenderFns }